import { render, staticRenderFns } from "./CourseFinishedDialog.vue?vue&type=template&id=24d6e1a2&"
import script from "./CourseFinishedDialog.vue?vue&type=script&lang=ts&"
export * from "./CourseFinishedDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports